<div class="footer">
    <img src="../../../assets/images/logo/GOINGPLACES_centered_RGB.png" height="78" alt="Going Places" id="logo" data-height-percentage="70" data-actual-height="78">
</div>